import { useState } from "react";
import { PayShareType } from "../types/payShareTypes";

export const usePayShareTable = () => {
  const [selectedStudentKeys, setSelectedStudentKeys] = useState<React.Key[]>(
    []
  );

  // Handle search
  const handleSearch = (value: string, setCurrentPage: (page: number) => void) => {
    setCurrentPage(1);
  };

  // Handle selection change
  const handleSelectionChange = (selectedKeys: React.Key[]) => {
    setSelectedStudentKeys(selectedKeys);
  };

  // Get checkbox props for selection
  const getCheckboxProps = (record: PayShareType) => ({
    disabled:
      record.payment_status === "paid" ||
      record.amount <= 0 ||
      record.share_amount <= 0, // Disable selection for paid records or those with no fee/share data
    name: record.student_name,
  });

  return {
    selectedStudentKeys,
    setSelectedStudentKeys,
    handleSearch,
    handleSelectionChange,
    getCheckboxProps,
  };
}; 